import { LanguageChoice } from 'app/i18n'
import { Ref, ref } from 'vue'

type UseFormatDateReturn = (
  date?: Date,
  options?: { language_choice: Ref<LanguageChoice> | Ref<'en'> }
) => {
  month: (options?: Intl.DateTimeFormatOptions) => string
  weekday: (options?: Intl.DateTimeFormatOptions) => string
  day: (options?: Intl.DateTimeFormatOptions) => string
  time: (options?: Intl.DateTimeFormatOptions) => string
}

/**
 * Get formatted month, weekday, and day. For elapsed/running time see formatTime.
 * @param date
 * @param options
 * @returns
 */
export const useFormatDate: UseFormatDateReturn = (
  date = new Date(),
  options = { language_choice: ref('en') }
) => {
  const format = (x: Intl.DateTimeFormatOptions) => {
    return new Intl.DateTimeFormat(options.language_choice.value.replaceAll('_', '-'), x).format(
      date
    )
    //    return new Intl.DateTimeFormat(useStore().user.language.replaceAll('_', '-'), x).format(date)
  }

  const month = (optionsDTF: Intl.DateTimeFormatOptions = { month: 'long' }) => format(optionsDTF)
  const weekday = (optionsDTF: Intl.DateTimeFormatOptions = { weekday: 'long' }) =>
    format(optionsDTF)
  const day = (optionsDTF: Intl.DateTimeFormatOptions = { day: 'numeric' }) => format(optionsDTF)
  const time = (optionsDTF: Intl.DateTimeFormatOptions = { hour: 'numeric', minute: '2-digit' }) =>
    format(optionsDTF)
  return {
    month,
    weekday,
    day,
    time,
  }
}
